import { toUsStateCode } from "./usStates.mjs";

// src/utils/stateToTimezone.ts
/**
* Maps US states to their corresponding IANA timezone identifiers.
* Primary timezone per state (admin / customer-facing defaults).
*/
const DEFAULT_US_CUSTOMER_TIMEZONE = "America/New_York";
const STATE_TO_PRIMARY_TIMEZONE = {
	AL: "America/Chicago",
	AK: "America/Anchorage",
	AZ: "America/Phoenix",
	AR: "America/Chicago",
	CA: "America/Los_Angeles",
	CO: "America/Denver",
	CT: "America/New_York",
	DE: "America/New_York",
	FL: "America/New_York",
	GA: "America/New_York",
	HI: "Pacific/Honolulu",
	ID: "America/Denver",
	IL: "America/Chicago",
	IN: "America/New_York",
	IA: "America/Chicago",
	KS: "America/Chicago",
	KY: "America/New_York",
	LA: "America/Chicago",
	ME: "America/New_York",
	MD: "America/New_York",
	MA: "America/New_York",
	MI: "America/New_York",
	MN: "America/Chicago",
	MS: "America/Chicago",
	MO: "America/Chicago",
	MT: "America/Denver",
	NE: "America/Chicago",
	NV: "America/Los_Angeles",
	NH: "America/New_York",
	NJ: "America/New_York",
	NM: "America/Denver",
	NY: "America/New_York",
	NC: "America/New_York",
	ND: "America/Chicago",
	OH: "America/New_York",
	OK: "America/Chicago",
	OR: "America/Los_Angeles",
	PA: "America/New_York",
	RI: "America/New_York",
	SC: "America/New_York",
	SD: "America/Chicago",
	TN: "America/Chicago",
	TX: "America/Chicago",
	UT: "America/Denver",
	VT: "America/New_York",
	VA: "America/New_York",
	WA: "America/Los_Angeles",
	WV: "America/New_York",
	WI: "America/Chicago",
	WY: "America/Denver"
};
/**
* Resolves an IANA timezone for a US state (full name or two-letter abbreviation).
* Returns `null` when state is missing or unrecognized.
*/
function getUsTimeZoneForState(state) {
	const stateAbbreviation = toUsStateCode(state);
	if (!stateAbbreviation) return null;
	return STATE_TO_PRIMARY_TIMEZONE[stateAbbreviation] ?? null;
}
/**
* Gets the timezone for a given US state name or abbreviation.
* Falls back to {@link DEFAULT_US_CUSTOMER_TIMEZONE} when state is missing or unknown.
*/
function getTimezoneForStateName(stateName) {
	return getUsTimeZoneForState(stateName) ?? "America/New_York";
}
/**
* Gets the timezone abbreviation for a given timezone
* @param timezone - IANA timezone identifier
* @returns Timezone abbreviation (e.g., 'EST', 'PST', 'CST')
*/
function getTimezoneAbbreviation(timezone) {
	try {
		const now = /* @__PURE__ */ new Date();
		return new Intl.DateTimeFormat("en-US", {
			timeZone: timezone,
			timeZoneName: "short"
		}).formatToParts(now).find((part) => part.type === "timeZoneName")?.value || timezone;
	} catch (error) {
		console.error("Error getting timezone abbreviation:", error);
		return timezone;
	}
}

export { DEFAULT_US_CUSTOMER_TIMEZONE, getTimezoneAbbreviation, getTimezoneForStateName, getUsTimeZoneForState };
//# sourceMappingURL=stateToTimezone.mjs.map